// src/glyphs.ts
var IconDef = {
  dir: { glyph: "\uF74A", color: [224, 177, 77] },
  diropen: { glyph: "\uFC6E", color: [224, 177, 77] },
  exe: { glyph: "\uF713", color: [76, 175, 80] },
  file: { glyph: "\uF723", color: [65, 129, 190] },
  hiddendir: { glyph: "\uF755", color: [224, 177, 77] },
  hiddenfile: { glyph: "\uFB12", color: [65, 129, 190] }
};
var IconSet = {
  "3d": { glyph: "\uE79B", color: [40, 182, 246] },
  actionscript: { glyph: "\uFB25", color: [244, 68, 62] },
  alpine: { glyph: "\uF300", color: [14, 87, 123] },
  android: { glyph: "\uF531", color: [139, 195, 74] },
  apiblueprint: { glyph: "\uF031", color: [66, 165, 245] },
  applescript: { glyph: "\uF302", color: [120, 144, 156] },
  arch: { glyph: "\uF303", color: [33, 142, 202] },
  arduino: { glyph: "\uE255", color: [35, 151, 156] },
  asciidoc: { glyph: "\uF718", color: [244, 68, 62] },
  assembly: { glyph: "\uF471", color: [250, 109, 63] },
  audio: { glyph: "\uFB75", color: [239, 83, 80] },
  authors: { glyph: "\uF0C0", color: [244, 68, 62] },
  autohotkey: { glyph: "\uF812", color: [76, 175, 80] },
  azure: { glyph: "\uFD03", color: [31, 136, 229] },
  "azure-pipelines": { glyph: "\uF427", color: [20, 101, 192] },
  babel: { glyph: "\uF5A0", color: [253, 217, 59] },
  bitbucket: { glyph: "\uF171", color: [31, 136, 229] },
  blink: { glyph: "\uF72A", color: [249, 169, 60] },
  bower: { glyph: "\uE61A", color: [239, 88, 60] },
  c: { glyph: "\uFB70", color: [2, 119, 189] },
  cake: { glyph: "\uF5EA", color: [250, 111, 66] },
  centOS: { glyph: "\uF304", color: [157, 83, 135] },
  certificate: { glyph: "\uF623", color: [249, 89, 63] },
  changelog: { glyph: "\uFBA6", color: [139, 195, 74] },
  clojure: { glyph: "\uE76A", color: [100, 221, 23] },
  cmake: { glyph: "\uF425", color: [178, 178, 179] },
  coconut: { glyph: "\uF5D2", color: [141, 110, 99] },
  "code-climate": { glyph: "\uF7F4", color: [238, 238, 238] },
  codecov: { glyph: "\uE37C", color: [237, 80, 122] },
  codeowners: { glyph: "\uF507", color: [175, 180, 43] },
  coffee: { glyph: "\uF675", color: [66, 165, 245] },
  command: { glyph: "\uFB32", color: [175, 188, 194] },
  commitlint: { glyph: "\uFC16", color: [43, 150, 137] },
  conduct: { glyph: "\uF64B", color: [205, 220, 57] },
  console: { glyph: "\uF68C", color: [250, 111, 66] },
  contributing: { glyph: "\uF64D", color: [255, 202, 61] },
  cpp: { glyph: "\uFB71", color: [2, 119, 189] },
  credits: { glyph: "\uF75F", color: [156, 204, 101] },
  csharp: { glyph: "\uF81A", color: [2, 119, 189] },
  css: { glyph: "\uF81B", color: [66, 165, 245] },
  "css-map": { glyph: "\uE749", color: [66, 165, 245] },
  d: { glyph: "\uE7AF", color: [244, 68, 62] },
  dart: { glyph: "\uE798", color: [87, 182, 240] },
  database: { glyph: "\uE706", color: [255, 202, 61] },
  debian: { glyph: "\uF306", color: [211, 61, 76] },
  denizenscript: { glyph: "D", color: [255, 213, 79] },
  dhall: { glyph: "\uF448", color: [120, 144, 156] },
  "dir-config": { glyph: "\uE5FC", color: [32, 173, 194] },
  "dir-controller": { glyph: "\uE5FC", color: [255, 194, 61] },
  "dir-download": { glyph: "\uF74C", color: [76, 175, 80] },
  "dir-environment": { glyph: "\uF74E", color: [102, 187, 106] },
  "dir-git": { glyph: "\uE5FB", color: [250, 111, 66] },
  "dir-github": { glyph: "\uE5FD", color: [84, 110, 122] },
  "dir-images": { glyph: "\uF74E", color: [43, 150, 137] },
  "dir-import": { glyph: "\uF756", color: [175, 180, 43] },
  "dir-include": { glyph: "\uF756", color: [3, 155, 229] },
  "dir-npm": { glyph: "\uE5FA", color: [203, 56, 55] },
  "dir-secure": { glyph: "\uF74F", color: [249, 169, 60] },
  "dir-upload": { glyph: "\uF758", color: [250, 111, 66] },
  disc: { glyph: "\uE271", color: [176, 190, 197] },
  django: { glyph: "\uE71D", color: [67, 160, 71] },
  docker: { glyph: "\uF308", color: [1, 135, 201] },
  document: { glyph: "\uF718", color: [66, 165, 245] },
  dune: { glyph: "\uF7F4", color: [244, 127, 61] },
  edge: { glyph: "\uF564", color: [239, 111, 60] },
  ejs: { glyph: "\uE618", color: [255, 202, 61] },
  elixir: { glyph: "\uE62D", color: [149, 117, 205] },
  elm: { glyph: "\uE62C", color: [96, 181, 204] },
  email: { glyph: "\uF6ED", color: [66, 165, 245] },
  erlang: { glyph: "\uE7B1", color: [244, 68, 62] },
  eslint: { glyph: "\uFBF6", color: [121, 134, 203] },
  exe: { glyph: "\uF2D0", color: [229, 77, 58] },
  fastlane: { glyph: "\uFBFF", color: [149, 119, 232] },
  favicon: { glyph: "\uE623", color: [255, 213, 79] },
  fedora: { glyph: "\uF30A", color: [52, 103, 172] },
  firebase: { glyph: "\uE787", color: [251, 193, 60] },
  flash: { glyph: "\uF740", color: [198, 52, 54] },
  font: { glyph: "\uF031", color: [244, 68, 62] },
  fortran: { glyph: "F", color: [250, 111, 66] },
  freebsd: { glyph: "\uF30C", color: [175, 44, 42] },
  fsharp: { glyph: "\uE7A7", color: [55, 139, 186] },
  gcp: { glyph: "\uF662", color: [70, 136, 250] },
  gemfile: { glyph: "\uE21E", color: [229, 61, 58] },
  gentoo: { glyph: "\uF30D", color: [148, 141, 211] },
  git: { glyph: "\uE702", color: [229, 77, 58] },
  gitlab: { glyph: "\uF296", color: [226, 69, 57] },
  go: { glyph: "\uFCD1", color: [32, 173, 194] },
  "go-mod": { glyph: "\uFCD1", color: [237, 80, 122] },
  "go-test": { glyph: "\uFCD1", color: [255, 213, 79] },
  godot: { glyph: "\uFBA7", color: [79, 195, 247] },
  "godot-assets": { glyph: "\uFBA7", color: [129, 199, 132] },
  gradle: { glyph: "\uFCC4", color: [29, 151, 167] },
  graphql: { glyph: "\uE284", color: [237, 80, 122] },
  groovy: { glyph: "\uF2A6", color: [41, 198, 218] },
  grunt: { glyph: "\uE611", color: [251, 170, 61] },
  gulp: { glyph: "\uE763", color: [229, 61, 58] },
  h: { glyph: "h", color: [2, 119, 189] },
  handlebars: { glyph: "\uE60F", color: [250, 111, 66] },
  haskell: { glyph: "\uE61F", color: [254, 168, 62] },
  haxe: { glyph: "\uF425", color: [246, 137, 61] },
  helm: { glyph: "\uFD31", color: [32, 173, 194] },
  heroku: { glyph: "\uE607", color: [105, 99, 185] },
  hpp: { glyph: "h", color: [2, 119, 189] },
  html: { glyph: "\uF13B", color: [228, 79, 57] },
  http: { glyph: "\uF484", color: [66, 165, 245] },
  husky: { glyph: "\uF8E8", color: [229, 229, 229] },
  i18n: { glyph: "\uF7BE", color: [121, 134, 203] },
  image: { glyph: "\uF71E", color: [48, 166, 154] },
  ionic: { glyph: "\uE7A9", color: [79, 143, 247] },
  java: { glyph: "\uF675", color: [244, 68, 62] },
  javascript: { glyph: "\uE74E", color: [255, 202, 61] },
  "javascript-map": { glyph: "\uE781", color: [255, 202, 61] },
  jenkins: { glyph: "\uE767", color: [240, 214, 183] },
  jest: { glyph: "J", color: [244, 85, 62] },
  jinja: { glyph: "\uE000", color: [174, 44, 42] },
  json: { glyph: "\uE60B", color: [251, 193, 60] },
  julia: { glyph: "\uE624", color: [134, 82, 159] },
  karma: { glyph: "\uE622", color: [60, 190, 174] },
  key: { glyph: "\uF805", color: [48, 166, 154] },
  kotlin: { glyph: "\uE70E", color: [139, 195, 74] },
  laravel: { glyph: "\uE73F", color: [248, 80, 81] },
  less: { glyph: "\uE60B", color: [2, 119, 189] },
  lib: { glyph: "\uF831", color: [139, 195, 74] },
  linux: { glyph: "\uE712", color: [238, 207, 55] },
  liquid: { glyph: "\uE275", color: [40, 182, 246] },
  lock: { glyph: "\uF83D", color: [255, 213, 79] },
  log: { glyph: "\uF719", color: [175, 180, 43] },
  lua: { glyph: "\uE620", color: [66, 165, 245] },
  makefile: { glyph: "\uF728", color: [239, 83, 80] },
  manjaro: { glyph: "\uF312", color: [73, 185, 90] },
  markdown: { glyph: "\uF853", color: [66, 165, 245] },
  markojs: { glyph: "\uF13B", color: [2, 119, 189] },
  mdx: { glyph: "\uF853", color: [255, 202, 61] },
  merlin: { glyph: "\uF136", color: [66, 165, 245] },
  mint: { glyph: "\uF30F", color: [125, 190, 58] },
  mjml: { glyph: "\uE714", color: [249, 89, 63] },
  mocha: { glyph: "\uF6A9", color: [161, 136, 127] },
  modernizr: { glyph: "\uE720", color: [234, 72, 99] },
  moonscript: { glyph: "\uF186", color: [251, 193, 60] },
  mxml: { glyph: "\uF72D", color: [254, 168, 62] },
  mysql: { glyph: "\uE704", color: [1, 94, 134] },
  nim: { glyph: "\uF6A4", color: [255, 202, 61] },
  nix: { glyph: "\uF313", color: [80, 117, 193] },
  nodejs: { glyph: "\uF898", color: [139, 195, 74] },
  npm: { glyph: "\uE71E", color: [203, 56, 55] },
  nuget: { glyph: "\uE77F", color: [3, 136, 209] },
  nuxt: { glyph: "\uE2A6", color: [65, 184, 131] },
  ocaml: { glyph: "\uF1CE", color: [253, 154, 62] },
  opam: { glyph: "\uF1CE", color: [255, 213, 79] },
  opensuse: { glyph: "\uF314", color: [111, 180, 36] },
  pascal: { glyph: "\uF8DA", color: [3, 136, 209] },
  pawn: { glyph: "\uE261", color: [239, 111, 60] },
  pdf: { glyph: "\uF724", color: [244, 68, 62] },
  perl: { glyph: "\uE769", color: [149, 117, 205] },
  postcss: { glyph: "\uF81B", color: [244, 68, 62] },
  postgresql: { glyph: "\uE76E", color: [49, 99, 140] },
  powerpoint: { glyph: "\uF726", color: [209, 71, 51] },
  powershell: { glyph: "\uFCB5", color: [5, 169, 244] },
  prettier: { glyph: "\uF8E2", color: [86, 179, 180] },
  prolog: { glyph: "\uE7A1", color: [239, 83, 80] },
  protractor: { glyph: "\uF288", color: [229, 61, 58] },
  pug: { glyph: "\uE60E", color: [239, 204, 163] },
  puppet: { glyph: "\uF595", color: [251, 193, 60] },
  purescript: { glyph: "\uF670", color: [66, 165, 245] },
  python: { glyph: "\uF81F", color: [52, 102, 143] },
  "python-misc": { glyph: "\uF820", color: [130, 61, 28] },
  qsharp: { glyph: "\uF292", color: [251, 193, 60] },
  r: { glyph: "\uFCD2", color: [25, 118, 210] },
  raml: { glyph: "\uE60B", color: [66, 165, 245] },
  "raspberry-pi": { glyph: "\uF315", color: [208, 60, 76] },
  razor: { glyph: "\uF564", color: [66, 165, 245] },
  react: { glyph: "\uE7BA", color: [35, 188, 212] },
  react_ts: { glyph: "\uE7BA", color: [36, 142, 211] },
  readme: { glyph: "\uF7FB", color: [66, 165, 245] },
  redhat: { glyph: "\uF316", color: [231, 61, 58] },
  roadmap: { glyph: "\uFB6D", color: [48, 166, 154] },
  robot: { glyph: "\uFBA7", color: [249, 89, 63] },
  routing: { glyph: "\uFB40", color: [67, 160, 71] },
  ruby: { glyph: "\uE739", color: [229, 61, 58] },
  rust: { glyph: "\uE7A8", color: [250, 111, 66] },
  sass: { glyph: "\uE603", color: [237, 80, 122] },
  scheme: { glyph: "\uFB26", color: [244, 68, 62] },
  "semantic-release": { glyph: "\uF70F", color: [245, 245, 245] },
  settings: { glyph: "\uF013", color: [66, 165, 245] },
  shaderlab: { glyph: "\uFBAD", color: [25, 118, 210] },
  sketch: { glyph: "\uF6C7", color: [255, 194, 61] },
  slim: { glyph: "\uF24E", color: [245, 129, 61] },
  smarty: { glyph: "\uF834", color: [255, 207, 60] },
  solidity: { glyph: "\uFCB9", color: [3, 136, 209] },
  sqlite: { glyph: "\uE7C4", color: [1, 57, 84] },
  storybook: { glyph: "\uFD2C", color: [237, 80, 122] },
  stryker: { glyph: "\uF05B", color: [239, 83, 80] },
  stylelint: { glyph: "\uFB76", color: [207, 216, 220] },
  stylus: { glyph: "\uE600", color: [192, 202, 51] },
  sublime: { glyph: "\uE7AA", color: [239, 148, 58] },
  svg: { glyph: "\uFC1F", color: [255, 181, 62] },
  swc: { glyph: "\uFBD3", color: [198, 52, 54] },
  swift: { glyph: "\uFBE3", color: [249, 95, 63] },
  table: { glyph: "\uF71A", color: [139, 195, 74] },
  tailwindcss: { glyph: "\uFC8B", color: [77, 182, 172] },
  tcl: { glyph: "\uFBD1", color: [239, 83, 80] },
  terraform: { glyph: "\uE20F", color: [92, 107, 192] },
  "test-js": { glyph: "\uF595", color: [255, 202, 61] },
  "test-jsx": { glyph: "\uF595", color: [35, 188, 212] },
  "test-ts": { glyph: "\uF595", color: [3, 136, 209] },
  tex: { glyph: "\uF783", color: [66, 165, 245] },
  todo: { glyph: "\uF058", color: [124, 179, 66] },
  travis: { glyph: "\uE77E", color: [203, 58, 73] },
  tune: { glyph: "\uFB69", color: [251, 193, 60] },
  twig: { glyph: "\uE61C", color: [155, 185, 47] },
  typescript: { glyph: "\uE628", color: [3, 136, 209] },
  "typescript-def": { glyph: "\uFBE4", color: [3, 136, 209] },
  ubuntu: { glyph: "\uF31C", color: [214, 73, 53] },
  url: { glyph: "\uF836", color: [66, 165, 245] },
  vagrant: { glyph: "\uF27D", color: [20, 101, 192] },
  vala: { glyph: "\uF7AB", color: [149, 117, 205] },
  vercel: { glyph: "\uF47E", color: [207, 216, 220] },
  verilog: { glyph: "\uFB19", color: [250, 111, 66] },
  video: { glyph: "\uF72A", color: [253, 154, 62] },
  vim: { glyph: "\uE62B", color: [67, 160, 71] },
  virtual: { glyph: "\uF822", color: [3, 155, 229] },
  visualstudio: { glyph: "\uE70C", color: [173, 99, 188] },
  vscode: { glyph: "\uE70C", color: [33, 150, 243] },
  vue: { glyph: "\uFD42", color: [65, 184, 131] },
  "vue-config": { glyph: "\uFD42", color: [58, 121, 110] },
  webpack: { glyph: "\uFC29", color: [142, 214, 251] },
  word: { glyph: "\uF72B", color: [1, 87, 155] },
  xaml: { glyph: "\uFB72", color: [66, 165, 245] },
  xml: { glyph: "\uF72D", color: [64, 153, 69] },
  yaml: { glyph: "\uE60B", color: [244, 68, 62] },
  yang: { glyph: "\uFB7E", color: [66, 165, 245] },
  yarn: { glyph: "\uF61A", color: [44, 142, 187] },
  zig: { glyph: "Z", color: [249, 169, 60] },
  zip: { glyph: "\uF410", color: [175, 180, 43] }
};

// src/directories.ts
var IconDir = {
  ".config": IconSet["dir-config"],
  ".env": IconSet["dir-environment"],
  ".environment": IconSet["dir-environment"],
  ".git": IconSet["dir-git"],
  ".githooks": IconSet["dir-git"],
  ".github": IconSet["dir-github"],
  ".settings": IconSet["dir-config"],
  ".submodules": IconSet["dir-git"],
  "META-INF": IconSet["dir-config"],
  _includes: IconSet["dir-include"],
  auth: IconSet["dir-secure"],
  authentication: IconSet["dir-secure"],
  cert: IconSet["dir-secure"],
  certificate: IconSet["dir-secure"],
  certificates: IconSet["dir-secure"],
  certs: IconSet["dir-secure"],
  config: IconSet["dir-config"],
  configs: IconSet["dir-config"],
  configuration: IconSet["dir-config"],
  configurations: IconSet["dir-config"],
  controller: IconSet["dir-controller"],
  controllers: IconSet["dir-controller"],
  download: IconSet["dir-download"],
  downloads: IconSet["dir-download"],
  env: IconSet["dir-environment"],
  environment: IconSet["dir-environment"],
  environments: IconSet["dir-environment"],
  githooks: IconSet["dir-git"],
  ico: IconSet["dir-images"],
  icon: IconSet["dir-images"],
  icons: IconSet["dir-images"],
  image: IconSet["dir-images"],
  images: IconSet["dir-images"],
  img: IconSet["dir-images"],
  import: IconSet["dir-import"],
  imported: IconSet["dir-import"],
  imports: IconSet["dir-import"],
  include: IconSet["dir-include"],
  includes: IconSet["dir-include"],
  node_modules: IconSet["dir-npm"],
  pic: IconSet["dir-images"],
  pics: IconSet["dir-images"],
  picture: IconSet["dir-images"],
  pictures: IconSet["dir-images"],
  provider: IconSet["dir-controller"],
  providers: IconSet["dir-controller"],
  screenshot: IconSet["dir-images"],
  screenshots: IconSet["dir-images"],
  secure: IconSet["dir-secure"],
  security: IconSet["dir-secure"],
  service: IconSet["dir-controller"],
  services: IconSet["dir-controller"],
  settings: IconSet["dir-config"],
  ssl: IconSet["dir-secure"],
  submodules: IconSet["dir-git"],
  upload: IconSet["dir-upload"],
  uploads: IconSet["dir-upload"]
};

// src/extensions.ts
var IconExt = {
  "4th": IconDef.file,
  // "forth" not available
  "7z": IconSet["zip"],
  a51: IconSet["assembly"],
  abc: IconDef.file,
  // "abc" not available
  ac: IconSet["3d"],
  accdb: IconSet["database"],
  ad: IconSet["asciidoc"],
  adoc: IconSet["asciidoc"],
  aea: IconSet["assembly"],
  afphoto: IconSet["image"],
  agc: IconSet["assembly"],
  ags: IconSet["assembly"],
  ahk: IconSet["autohotkey"],
  aiff: IconSet["audio"],
  ami: IconSet["image"],
  amx: IconSet["pawn"],
  apib: IconSet["apiblueprint"],
  apiblueprint: IconSet["apiblueprint"],
  apk: IconSet["android"],
  applescript: IconSet["applescript"],
  apx: IconSet["image"],
  argus: IconSet["assembly"],
  as: IconSet["actionscript"],
  asc: IconSet["key"],
  asciidoc: IconSet["asciidoc"],
  ase: IconSet["image"],
  aseprite: IconSet["image"],
  asm: IconSet["assembly"],
  asp: IconSet["html"],
  ast: IconDef.file,
  // "sas" not available
  astore: IconDef.file,
  // "sas" not available
  au3: IconDef.file,
  // "autoit" not available
  avi: IconSet["video"],
  awk: IconSet["console"],
  azcli: IconSet["azure"],
  bal: IconDef.file,
  // "ballerina" not available
  balx: IconDef.file,
  // "ballerina" not available
  bash: IconSet["console"],
  bat: IconSet["console"],
  bazel: IconDef.file,
  // "bazel" not available
  bib: IconSet["lib"],
  binsource: IconSet["assembly"],
  blend: IconSet["3d"],
  blink: IconSet["blink"],
  bmap: IconSet["font"],
  bmp: IconSet["image"],
  bpg: IconSet["image"],
  br: IconSet["zip"],
  brk: IconSet["image"],
  brotli: IconSet["zip"],
  bzip2: IconSet["zip"],
  bzl: IconDef.file,
  // "bazel" not available
  c: IconSet["c"],
  "c++": IconSet["cpp"],
  cabal: IconDef.file,
  // "cabal" not available
  cake: IconSet["cake"],
  cc: IconSet["cpp"],
  cer: IconSet["certificate"],
  cert: IconSet["certificate"],
  cfc: IconDef.file,
  // "coldfusion" not available
  cfg: IconSet["settings"],
  cfm: IconDef.file,
  // "coldfusion" not available
  cfml: IconDef.file,
  // "coldfusion" not available
  ch: IconDef.file,
  // "advpl_include" not available
  cl: IconDef.file,
  // "lisp" not available
  clip: IconSet["image"],
  clj: IconSet["clojure"],
  cljc: IconSet["clojure"],
  cljs: IconSet["clojure"],
  cm: IconDef.file,
  // "sml" not available
  cmake: IconSet["cmake"],
  cmd: IconSet["console"],
  cmj: IconDef.file,
  // "bucklescript" not available
  cmx: IconSet["ocaml"],
  coco: IconSet["coconut"],
  "code-workplace": IconSet["vscode"],
  coffee: IconSet["coffee"],
  command: IconSet["command"],
  conf: IconSet["settings"],
  config: IconSet["settings"],
  cp: IconSet["cpp"],
  cpp: IconSet["cpp"],
  cpt: IconSet["image"],
  cr: IconDef.file,
  // "crystal" not available
  crt: IconSet["certificate"],
  cs: IconSet["csharp"],
  csh: IconSet["console"],
  cshtml: IconSet["razor"],
  cson: IconSet["coffee"],
  csproj: IconSet["visualstudio"],
  css: IconSet["css"],
  csv: IconSet["table"],
  csx: IconSet["csharp"],
  cu: IconDef.file,
  // "cuda" not available
  cuh: IconDef.file,
  // "cuda" not available
  cur: IconSet["image"],
  cxx: IconSet["cpp"],
  d: IconSet["d"],
  dart: IconSet["dart"],
  dds: IconSet["image"],
  deb: IconSet["debian"],
  def: IconDef.file,
  // "dotjs" not available
  dhall: IconSet["dhall"],
  dhallb: IconSet["dhall"],
  dio: IconDef.file,
  // "drawio" not available
  djt: IconSet["django"],
  dlc: IconSet["settings"],
  dll: IconSet["settings"],
  dng: IconSet["image"],
  doc: IconSet["word"],
  dockerfile: IconSet["docker"],
  dockerignore: IconSet["docker"],
  docx: IconSet["word"],
  dot: IconDef.file,
  // "dotjs" not available
  dotsettings: IconSet["settings"],
  drawio: IconDef.file,
  // "drawio" not available
  dsc: IconSet["denizenscript"],
  dtd: IconSet["xml"],
  dtx: IconSet["tex"],
  ebuild: IconSet["gentoo"],
  ecr: IconDef.file,
  // "crystal" not available
  edge: IconSet["edge"],
  eex: IconSet["elixir"],
  ejs: IconSet["ejs"],
  elm: IconSet["elm"],
  env: IconSet["tune"],
  eot: IconSet["font"],
  eps: IconSet["image"],
  erb: IconSet["ruby"],
  erl: IconSet["erlang"],
  esx: IconSet["javascript"],
  ex: IconSet["elixir"],
  exe: IconSet["exe"],
  exr: IconSet["image"],
  exrc: IconSet["vim"],
  exs: IconSet["elixir"],
  f: IconSet["fortran"],
  f03: IconSet["fortran"],
  f08: IconSet["fortran"],
  f77: IconSet["fortran"],
  f90: IconSet["fortran"],
  f95: IconSet["fortran"],
  fast: IconDef.file,
  // "lisp" not available
  feature: IconDef.file,
  // "cucumber" not available
  fhtml: IconDef.file,
  // "velocity" not available
  fish: IconSet["console"],
  flac: IconSet["audio"],
  flv: IconSet["video"],
  fnt: IconSet["font"],
  font: IconSet["font"],
  fonts: IconSet["font"],
  fpx: IconSet["image"],
  frt: IconDef.file,
  // "forth" not available
  fs: IconSet["fsharp"],
  fsi: IconSet["fsharp"],
  fsproj: IconSet["fsharp"],
  fsx: IconSet["fsharp"],
  fth: IconDef.file,
  // "forth" not available
  fun: IconDef.file,
  // "sml" not available
  fxp: IconDef.file,
  // "foxpro" not available
  gbr: IconSet["image"],
  gd: IconSet["godot"],
  gif: IconSet["image"],
  gifv: IconSet["video"],
  go: IconSet["go"],
  godot: IconSet["godot-assets"],
  gpg: IconSet["key"],
  gql: IconSet["graphql"],
  gradle: IconSet["gradle"],
  graphcool: IconDef.file,
  // "graphcool" not available
  graphql: IconSet["graphql"],
  grm: IconDef.file,
  // "sml" not available
  groovy: IconSet["groovy"],
  gvimrc: IconSet["vim"],
  gz: IconSet["zip"],
  gzip: IconSet["zip"],
  h: IconSet["h"],
  "h++": IconSet["hpp"],
  haml: IconDef.file,
  // "haml" not available
  hbs: IconSet["handlebars"],
  hcl: IconDef.file,
  // "hcl" not available
  heic: IconSet["image"],
  heif: IconSet["image"],
  hh: IconSet["hpp"],
  hp: IconSet["hpp"],
  hpp: IconSet["hpp"],
  hs: IconSet["haskell"],
  htm: IconSet["html"],
  html: IconSet["html"],
  html_vm: IconSet["html"],
  http: IconSet["http"],
  hx: IconSet["haxe"],
  hxx: IconSet["hpp"],
  i: IconSet["c"],
  iced: IconSet["coffee"],
  ico: IconSet["image"],
  ics: IconSet["email"],
  ii: IconSet["cpp"],
  imba: IconDef.file,
  // "imba" not available
  img: IconSet["image"],
  iml: IconSet["xml"],
  inc: IconSet["assembly"],
  ini: IconSet["settings"],
  inl: IconSet["hpp"],
  ino: IconSet["arduino"],
  ipa: IconSet["applescript"],
  ipynb: IconDef.file,
  // "jupyter" not available
  iso: IconSet["disc"],
  iuml: IconDef.file,
  // "uml" not available
  j2: IconSet["jinja"],
  jade: IconSet["pug"],
  jar: IconSet["java"],
  java: IconSet["java"],
  jb2: IconSet["image"],
  jbig2: IconSet["image"],
  jenkins: IconSet["jenkins"],
  jenkinsfile: IconSet["jenkins"],
  jinja: IconSet["jinja"],
  "jinja-html": IconSet["jinja"],
  jinja2: IconSet["jinja"],
  jl: IconSet["julia"],
  jng: IconSet["image"],
  jpeg: IconSet["image"],
  jpg: IconSet["image"],
  js: IconSet["javascript"],
  json: IconSet["json"],
  json5: IconSet["json"],
  jsonl: IconSet["json"],
  jsp: IconSet["java"],
  jst: IconDef.file,
  // "dotjs" not available
  jsx: IconSet["react"],
  jxr: IconSet["image"],
  key: IconSet["key"],
  kl: IconDef.file,
  // "kl" not available
  kra: IconSet["image"],
  ksh: IconSet["console"],
  kt: IconSet["kotlin"],
  kts: IconSet["kotlin"],
  kv: IconDef.file,
  // "kivy" not available
  leex: IconSet["elixir"],
  less: IconSet["less"],
  lex: IconDef.file,
  // "sml" not available
  lib: IconSet["lib"],
  liquid: IconSet["liquid"],
  lisp: IconDef.file,
  // "lisp" not available
  lock: IconSet["lock"],
  log: IconSet["log"],
  ls: IconDef.file,
  // "livescript" not available
  lsp: IconDef.file,
  // "lisp" not available
  ltx: IconSet["tex"],
  lua: IconSet["lua"],
  lucee: IconDef.file,
  // "coldfusion" not available
  m: IconSet["c"],
  m2v: IconSet["video"],
  m4a: IconSet["audio"],
  m4v: IconSet["video"],
  manifest: IconSet["xml"],
  markdown: IconSet["markdown"],
  marko: IconSet["markojs"],
  md: IconSet["markdown"],
  mdb: IconSet["database"],
  mdp: IconSet["image"],
  mdx: IconSet["mdx"],
  merlin: IconSet["merlin"],
  mesh: IconSet["3d"],
  mi: IconSet["c"],
  mii: IconSet["cpp"],
  mint: IconSet["mint"],
  mitigus: IconSet["assembly"],
  mj: IconSet["javascript"],
  mjml: IconSet["mjml"],
  mkv: IconSet["video"],
  ml: IconSet["ocaml"],
  mlb: IconDef.file,
  // "sml" not available
  mli: IconSet["ocaml"],
  mlton: IconDef.file,
  // "sml" not available
  mm: IconSet["cpp"],
  mo: IconSet["i18n"],
  moon: IconSet["moonscript"],
  mov: IconSet["video"],
  mp2: IconSet["video"],
  mp3: IconSet["audio"],
  mp4: IconSet["video"],
  mpe: IconSet["video"],
  mpeg: IconSet["video"],
  mpg: IconSet["video"],
  mpv: IconSet["video"],
  mqo: IconSet["3d"],
  mrf: IconSet["font"],
  ms: IconSet["assembly"],
  msi: IconSet["exe"],
  mustache: IconSet["handlebars"],
  mxml: IconSet["mxml"],
  nasm: IconSet["assembly"],
  nb: IconDef.file,
  // "mathematica" not available
  ndjson: IconSet["json"],
  nim: IconSet["nim"],
  nimble: IconSet["nim"],
  nix: IconSet["nix"],
  njk: IconDef.file,
  // "nunjucks" not available
  ntf: IconSet["font"],
  nunjucks: IconDef.file,
  // "nunjucks" not available
  nupkg: IconSet["nuget"],
  obj: IconSet["3d"],
  odttf: IconSet["font"],
  ogg: IconSet["video"],
  ogv: IconSet["video"],
  opam: IconSet["opam"],
  openbsd: IconSet["freebsd"],
  option: IconSet["settings"],
  ora: IconSet["image"],
  otf: IconSet["font"],
  p: IconSet["prolog"],
  pas: IconSet["pascal"],
  patch: IconSet["git"],
  pbm: IconSet["image"],
  pcss: IconSet["postcss"],
  pdb: IconSet["database"],
  pde: IconDef.file,
  // "processing" not available
  pdf: IconSet["pdf"],
  pdn: IconSet["image"],
  pem: IconSet["key"],
  pgf: IconSet["image"],
  pgsql: IconSet["postgresql"],
  pic: IconSet["image"],
  pkb: IconSet["database"],
  pkg: IconSet["applescript"],
  pks: IconSet["database"],
  plantuml: IconDef.file,
  // "uml" not available
  plist: IconSet["xml"],
  pm: IconSet["perl"],
  pmd: IconSet["3d"],
  pmx: IconSet["3d"],
  png: IconSet["image"],
  po: IconSet["i18n"],
  postgres: IconSet["postgresql"],
  pot: IconSet["i18n"],
  potm: IconSet["powerpoint"],
  potx: IconSet["powerpoint"],
  pp: IconSet["puppet"],
  ppa: IconSet["powerpoint"],
  ppam: IconSet["powerpoint"],
  pps: IconSet["powerpoint"],
  ppsm: IconSet["powerpoint"],
  ppsx: IconSet["powerpoint"],
  ppt: IconSet["powerpoint"],
  pptm: IconSet["powerpoint"],
  pptx: IconSet["powerpoint"],
  prefs: IconSet["settings"],
  prg: IconDef.file,
  // "foxpro" not available
  prisma: IconDef.file,
  // "prisma" not available
  pro: IconSet["prolog"],
  project: IconSet["xml"],
  prop: IconSet["settings"],
  properties: IconSet["settings"],
  props: IconSet["settings"],
  prw: IconDef.file,
  // "advpl_prw" not available
  prx: IconDef.file,
  // "advpl_prw" not available
  ps1: IconSet["powershell"],
  ps1xml: IconSet["powershell"],
  psb: IconSet["image"],
  psc1: IconSet["powershell"],
  psd: IconSet["image"],
  psd1: IconSet["powershell"],
  psm1: IconSet["powershell"],
  psql: IconSet["postgresql"],
  pssc: IconSet["powershell"],
  ptm: IconDef.file,
  // "advpl_ptm" not available
  pu: IconDef.file,
  // "uml" not available
  pub: IconSet["key"],
  pug: IconSet["pug"],
  puml: IconDef.file,
  // "uml" not available
  pure: IconSet["purescript"],
  purs: IconSet["purescript"],
  pwn: IconSet["pawn"],
  py: IconSet["python"],
  pyc: IconSet["python-misc"],
  qs: IconSet["qsharp"],
  qt: IconSet["video"],
  r: IconSet["r"],
  raku: IconSet["perl"],
  raml: IconSet["raml"],
  rar: IconSet["zip"],
  raw: IconSet["image"],
  rb: IconSet["ruby"],
  re: IconDef.file,
  // "reason" not available
  reb: IconSet["image"],
  red: IconDef.file,
  // "red" not available
  rei: IconDef.file,
  // "reason" not available
  rest: IconSet["http"],
  restql: IconDef.file,
  // "restql" not available
  resx: IconSet["xml"],
  riot: IconDef.file,
  // "riot" not available
  rkt: IconDef.file,
  // "racket" not available
  rm: IconSet["video"],
  rmd: IconSet["r"],
  rmvb: IconSet["video"],
  robot: IconSet["robot"],
  rpm: IconSet["redhat"],
  rql: IconDef.file,
  // "restql" not available
  rs: IconSet["rust"],
  rst: IconSet["markdown"],
  rtf: IconSet["word"],
  ruleset: IconSet["visualstudio"],
  s: IconSet["assembly"],
  sai: IconSet["image"],
  san: IconDef.file,
  // "san" not available
  sas: IconDef.file,
  // "sas" not available
  sas7bdat: IconDef.file,
  // "sas" not available
  sashdat: IconDef.file,
  // "sas" not available
  sass: IconSet["sass"],
  sast: IconDef.file,
  // "sas" not available
  sbt: IconDef.file,
  // "sbt" not available
  scm: IconSet["scheme"],
  scss: IconSet["sass"],
  settings: IconSet["settings"],
  sh: IconSet["console"],
  sig: IconDef.file,
  // "sml" not available
  sketch: IconSet["sketch"],
  skp: IconSet["3d"],
  slim: IconSet["slim"],
  sln: IconSet["visualstudio"],
  sml: IconDef.file,
  // "sml" not available
  snap: IconSet["ubuntu"],
  sol: IconSet["solidity"],
  sql: IconSet["mysql"],
  sqlite: IconSet["sqlite"],
  sqlite3: IconSet["sqlite"],
  ss: IconSet["scheme"],
  sss: IconSet["postcss"],
  stl: IconSet["3d"],
  sty: IconSet["tex"],
  styl: IconSet["stylus"],
  "sublime-project": IconSet["sublime"],
  "sublime-workspace": IconSet["sublime"],
  sui: IconSet["font"],
  suit: IconSet["font"],
  suo: IconSet["visualstudio"],
  sv: IconSet["verilog"],
  svelte: IconDef.file,
  // "svelte" not available
  svg: IconSet["svg"],
  svh: IconSet["verilog"],
  swc: IconSet["swc"],
  swf: IconSet["flash"],
  swift: IconSet["swift"],
  tag: IconDef.file,
  // "riot" not available
  tar: IconSet["zip"],
  tcc: IconSet["hpp"],
  tcl: IconSet["tcl"],
  tcsh: IconSet["console"],
  tex: IconSet["tex"],
  tf: IconSet["terraform"],
  tfstate: IconSet["terraform"],
  tfvars: IconSet["terraform"],
  tga: IconSet["image"],
  tgz: IconSet["zip"],
  tif: IconSet["image"],
  tiff: IconSet["image"],
  tlpp: IconDef.file,
  // "advpl_tlpp" not available
  tmLanguage: IconSet["xml"],
  todo: IconSet["todo"],
  toml: IconSet["settings"],
  tpl: IconSet["smarty"],
  tres: IconSet["godot-assets"],
  ts: IconSet["typescript"],
  tsbuildinfo: IconSet["json"],
  tscn: IconSet["godot-assets"],
  tsv: IconSet["table"],
  tsx: IconSet["react_ts"],
  ttc: IconSet["font"],
  ttf: IconSet["font"],
  twig: IconSet["twig"],
  txt: IconSet["document"],
  unity: IconSet["shaderlab"],
  url: IconSet["url"],
  use: IconDef.file,
  // "sml" not available
  v: IconSet["verilog"],
  vac: IconSet["3d"],
  vagrantfile: IconSet["vagrant"],
  vala: IconSet["vala"],
  vb: IconSet["visualstudio"],
  vbhtml: IconSet["razor"],
  vbox: IconSet["virtual"],
  "vbox-prev": IconSet["virtual"],
  vbs: IconSet["visualstudio"],
  vcxitems: IconSet["visualstudio"],
  vcxproj: IconSet["visualstudio"],
  vdi: IconSet["virtual"],
  vdp: IconSet["3d"],
  vfl: IconDef.file,
  // "vfl" not available
  vhd: IconSet["verilog"],
  vimrc: IconSet["vim"],
  vm: IconDef.file,
  // "velocity" not available
  vob: IconSet["video"],
  vox: IconSet["3d"],
  vscodeignore: IconSet["vscode"],
  vsix: IconSet["vscode"],
  vsixmanifest: IconSet["vscode"],
  vtl: IconDef.file,
  // "velocity" not available
  vue: IconSet["vue"],
  wasm: IconDef.file,
  // "webassembly" not available
  wat: IconDef.file,
  // "webassembly" not available
  webm: IconSet["video"],
  webp: IconSet["image"],
  whl: IconSet["python-misc"],
  wl: IconDef.file,
  // "wolframlanguage" not available
  wls: IconDef.file,
  // "wolframlanguage" not available
  wma: IconSet["audio"],
  wmv: IconSet["video"],
  woff: IconSet["font"],
  woff2: IconSet["font"],
  wpy: IconDef.file,
  // "wepy" not available
  wsd: IconDef.file,
  // "uml" not available
  xaml: IconSet["xaml"],
  xcf: IconSet["image"],
  xhtml: IconSet["html"],
  xls: IconSet["table"],
  xlsx: IconSet["table"],
  xml: IconSet["xml"],
  xquery: IconSet["xml"],
  xsd: IconSet["xml"],
  xsl: IconSet["xml"],
  xslt: IconSet["xml"],
  xz: IconSet["zip"],
  yaml: IconSet["yaml"],
  "yaml-tmlanguage": IconSet["yaml"],
  yang: IconSet["yang"],
  yml: IconSet["yaml"],
  yuv: IconSet["video"],
  zig: IconSet["zig"],
  zip: IconSet["zip"],
  zsh: IconSet["console"]
};

// src/filenames.ts
var IconFileName = {
  ".Rhistory": IconSet["r"],
  ".adonisrc.json": IconDef.file,
  // "adonis" not available
  ".appveyor.yml": IconDef.file,
  // "appveyor" not available
  ".babelrc": IconSet["babel"],
  ".babelrc.js": IconSet["babel"],
  ".babelrc.json": IconSet["babel"],
  ".bazelignore": IconDef.file,
  // "bazel" not available
  ".bazelrc": IconDef.file,
  // "bazel" not available
  ".bithoundrc": IconDef.file,
  // "bithound" not available
  ".bowerrc": IconSet["bower"],
  ".browserslistrc": IconDef.file,
  // "browserlist" not available
  ".buckconfig": IconDef.file,
  // "buck" not available
  ".buildignore": IconSet["settings"],
  ".cfignore": IconDef.file,
  // "cloudfoundry" not available
  ".clang-format": IconSet["settings"],
  ".clang-tidy": IconSet["settings"],
  ".codeclimate.yml": IconSet["code-climate"],
  ".codecov.yml": IconSet["codecov"],
  ".commitlint.yaml": IconSet["commitlint"],
  ".commitlint.yml": IconSet["commitlint"],
  ".commitlintrc": IconSet["commitlint"],
  ".commitlintrc.js": IconSet["commitlint"],
  ".commitlintrc.json": IconSet["commitlint"],
  ".drone.yml": IconDef.file,
  // "drone" not available
  ".editorconfig": IconDef.file,
  // "editorconfig" not available
  ".env.defaults": IconSet["tune"],
  ".env.dev": IconSet["tune"],
  ".env.development": IconSet["tune"],
  ".env.development.local": IconSet["tune"],
  ".env.example": IconSet["tune"],
  ".env.local": IconSet["tune"],
  ".env.preview": IconSet["tune"],
  ".env.prod": IconSet["tune"],
  ".env.production": IconSet["tune"],
  ".env.production.local": IconSet["tune"],
  ".env.qa": IconSet["tune"],
  ".env.qa.local": IconSet["tune"],
  ".env.sample": IconSet["tune"],
  ".env.schema": IconSet["tune"],
  ".env.staging": IconSet["tune"],
  ".env.staging.local": IconSet["tune"],
  ".env.test": IconSet["tune"],
  ".env.test.local": IconSet["tune"],
  ".env.testing": IconSet["tune"],
  ".esformatter": IconSet["json"],
  ".eslintcache": IconSet["eslint"],
  ".eslintignore": IconSet["eslint"],
  ".eslintrc": IconSet["eslint"],
  ".eslintrc.cjs": IconSet["eslint"],
  ".eslintrc.js": IconSet["eslint"],
  ".eslintrc.json": IconSet["eslint"],
  ".eslintrc.yaml": IconSet["eslint"],
  ".eslintrc.yml": IconSet["eslint"],
  ".esmrc": IconSet["nodejs"],
  ".firebaserc": IconSet["firebase"],
  ".flowconfig": IconDef.file,
  // "flow" not available
  ".gcloudignore": IconSet["gcp"],
  ".gitattributes": IconSet["git"],
  ".gitconfig": IconSet["git"],
  ".gitignore": IconSet["git"],
  ".gitkeep": IconSet["git"],
  ".gitmodules": IconSet["git"],
  ".gitpod.yml": IconDef.file,
  // "gitpod" not available
  ".graphqlconfig": IconSet["graphql"],
  ".helmignore": IconSet["helm"],
  ".hhconfig": IconDef.file,
  // "hack" not available
  ".hintrc": IconDef.file,
  // "webhint" not available
  ".htaccess": IconSet["xml"],
  ".htpasswd": IconSet["key"],
  ".huskyrc": IconSet["husky"],
  ".huskyrc.js": IconSet["husky"],
  ".huskyrc.json": IconSet["husky"],
  ".huskyrc.yaml": IconSet["husky"],
  ".huskyrc.yml": IconSet["husky"],
  ".io-config.json": IconSet["ionic"],
  ".jestrc": IconSet["jest"],
  ".jestrc.js": IconSet["jest"],
  ".jestrc.json": IconSet["jest"],
  ".jsbeautifyrc": IconSet["json"],
  ".jscsrc": IconSet["json"],
  ".jshintignore": IconSet["settings"],
  ".jshintrc": IconSet["json"],
  ".kl": IconDef.file,
  // "kl" not available
  ".luacheckrc": IconSet["lua"],
  ".mailmap": IconSet["email"],
  ".mjmlconfig": IconSet["json"],
  ".mocharc.js": IconSet["mocha"],
  ".mocharc.json": IconSet["mocha"],
  ".mocharc.jsonc": IconSet["mocha"],
  ".mocharc.yaml": IconSet["mocha"],
  ".mocharc.yml": IconSet["mocha"],
  ".modernizrrc": IconSet["modernizr"],
  ".modernizrrc.js": IconSet["modernizr"],
  ".modernizrrc.json": IconSet["modernizr"],
  ".mrconfig": IconSet["settings"],
  ".nest-cli.json": IconDef.file,
  // "nest" not available
  ".nestconfig.json": IconDef.file,
  // "nest" not available
  ".node-version": IconSet["nodejs"],
  ".nowignore": IconSet["vercel"],
  ".npmignore": IconSet["npm"],
  ".npmrc": IconSet["npm"],
  ".nuspec": IconSet["nuget"],
  ".nvmrc": IconSet["nodejs"],
  ".nycrc": IconDef.file,
  // "istanbul" not available
  ".nycrc.json": IconDef.file,
  // "istanbul" not available
  ".percy.yml": IconDef.file,
  // "percy" not available
  ".postcssrc": IconSet["postcss"],
  ".postcssrc.js": IconSet["postcss"],
  ".postcssrc.json": IconSet["postcss"],
  ".postcssrc.yml": IconSet["postcss"],
  ".prettierignore": IconSet["prettier"],
  ".prettierrc": IconSet["prettier"],
  ".prettierrc.js": IconSet["prettier"],
  ".prettierrc.json": IconSet["prettier"],
  ".prettierrc.yaml": IconSet["prettier"],
  ".prettierrc.yml": IconSet["prettier"],
  ".pug-lintrc": IconSet["pug"],
  ".pug-lintrc.js": IconSet["pug"],
  ".pug-lintrc.json": IconSet["pug"],
  ".python-version": IconSet["python-misc"],
  ".releaserc": IconSet["semantic-release"],
  ".releaserc.js": IconSet["semantic-release"],
  ".releaserc.json": IconSet["semantic-release"],
  ".releaserc.yaml": IconSet["semantic-release"],
  ".releaserc.yml": IconSet["semantic-release"],
  ".sequelizerc": IconDef.file,
  // "sequelize" not available
  ".slugignore": IconDef.file,
  // "slug" not available
  ".snyk": IconDef.file,
  // "snyk" not available
  ".stylelintignore": IconSet["stylelint"],
  ".stylelintrc": IconSet["stylelint"],
  ".stylelintrc.js": IconSet["stylelint"],
  ".stylelintrc.json": IconSet["stylelint"],
  ".stylelintrc.yaml": IconSet["stylelint"],
  ".stylelintrc.yml": IconSet["stylelint"],
  ".travis.yml": IconSet["travis"],
  ".vercelignore": IconSet["vercel"],
  ".vfl": IconDef.file,
  // "vfl" not available
  ".wakatime-project": IconDef.file,
  // "wakatime" not available
  ".watchmanconfig": IconDef.file,
  // "watchman" not available
  ".yardopts": IconSet["settings"],
  ".yarn-integrity": IconSet["yarn"],
  ".yarnclean": IconSet["yarn"],
  ".yarnrc": IconSet["yarn"],
  ".yarnrc.yaml": IconSet["yarn"],
  ".yarnrc.yml": IconSet["yarn"],
  CNAME: IconSet["http"],
  ace: IconDef.file,
  // "adonis" not available
  "androidmanifest.xml": IconSet["android"],
  "apollo.config.js": IconDef.file,
  // "apollo" not available
  appfile: IconSet["fastlane"],
  "appveyor.yml": IconDef.file,
  // "appveyor" not available
  "aurelia.json": IconDef.file,
  // "aurelia" not available
  authors: IconSet["authors"],
  "authors.md": IconSet["authors"],
  "authors.txt": IconSet["authors"],
  "azure-pipelines.yaml": IconSet["azure-pipelines"],
  "azure-pipelines.yml": IconSet["azure-pipelines"],
  "babel.config.js": IconSet["babel"],
  "babel.config.json": IconSet["babel"],
  "bitbucket-pipelines.yaml": IconSet["bitbucket"],
  "bitbucket-pipelines.yml": IconSet["bitbucket"],
  "bower.json": IconSet["bower"],
  browserslist: IconDef.file,
  // "browserlist" not available
  "buildkite.yaml": IconDef.file,
  // "buildkite" not available
  "buildkite.yml": IconDef.file,
  // "buildkite" not available
  "capacitor.config.json": IconDef.file,
  // "capacitor" not available
  "cdp.pid": IconSet["json"],
  changelog: IconSet["changelog"],
  "changelog.md": IconSet["changelog"],
  "changelog.txt": IconSet["changelog"],
  changes: IconSet["changelog"],
  "changes.md": IconSet["changelog"],
  "changes.txt": IconSet["changelog"],
  "circle.yml": IconDef.file,
  // "circleci" not available
  "cmakecache.txt": IconSet["cmake"],
  "cmakelists.txt": IconSet["cmake"],
  "code_of_conduct.md": IconSet["conduct"],
  "code_of_conduct.txt": IconSet["conduct"],
  "codecov.yml": IconSet["codecov"],
  codeowners: IconSet["codeowners"],
  "commitlint.config.js": IconSet["commitlint"],
  "composer.lock": IconSet["json"],
  "contributing.md": IconSet["contributing"],
  credits: IconSet["credits"],
  "credits.md": IconSet["credits"],
  "credits.txt": IconSet["credits"],
  "docker-compose.ci.yml": IconSet["docker"],
  "docker-compose.dev.yml": IconSet["docker"],
  "docker-compose.local.yml": IconSet["docker"],
  "docker-compose.override.yml": IconSet["docker"],
  "docker-compose.prod.yml": IconSet["docker"],
  "docker-compose.production.yml": IconSet["docker"],
  "docker-compose.staging.yml": IconSet["docker"],
  "docker-compose.test.yml": IconSet["docker"],
  "docker-compose.yaml": IconSet["docker"],
  "docker-compose.yml": IconSet["docker"],
  dockerfile: IconSet["docker"],
  "dockerfile.prod": IconSet["docker"],
  "dockerfile.production": IconSet["docker"],
  dune: IconSet["dune"],
  "dune-project": IconSet["dune"],
  fastfile: IconSet["fastlane"],
  "favicon.ico": IconSet["favicon"],
  "firebase.json": IconSet["firebase"],
  "firestore.indexes.json": IconSet["firebase"],
  "firestore.rules": IconSet["firebase"],
  "fuse.js": IconDef.file,
  // "fusebox" not available
  "gatsby-browser.js": IconDef.file,
  // "gatsby" not available
  "gatsby-config.js": IconDef.file,
  // "gatsby" not available
  "gatsby-node.js": IconDef.file,
  // "gatsby" not available
  "gatsby-ssr.js": IconDef.file,
  // "gatsby" not available
  "gatsby.config.js": IconDef.file,
  // "gatsby" not available
  gemfile: IconSet["gemfile"],
  "git-history": IconSet["git"],
  "go.mod": IconSet["go-mod"],
  "go.sum": IconSet["go-mod"],
  "gradle-wrapper.properties": IconSet["gradle"],
  "gradle.properties": IconSet["gradle"],
  gradlew: IconSet["gradle"],
  "gruntfile.babel.coffee": IconSet["grunt"],
  "gruntfile.babel.js": IconSet["grunt"],
  "gruntfile.babel.ts": IconSet["grunt"],
  "gruntfile.coffee": IconSet["grunt"],
  "gruntfile.js": IconSet["grunt"],
  "gruntfile.ts": IconSet["grunt"],
  "gulpfile.babel.js": IconSet["gulp"],
  "gulpfile.js": IconSet["gulp"],
  "gulpfile.mjs": IconSet["gulp"],
  "gulpfile.ts": IconSet["gulp"],
  "husky.config.js": IconSet["husky"],
  "ionic.config.json": IconSet["ionic"],
  jenkinsfile: IconSet["jenkins"],
  "jest.config.cjs": IconSet["jest"],
  "jest.config.js": IconSet["jest"],
  "jest.config.json": IconSet["jest"],
  "jest.config.mjs": IconSet["jest"],
  "jest.config.ts": IconSet["jest"],
  "jest.e2e.config.cjs": IconSet["jest"],
  "jest.e2e.config.js": IconSet["jest"],
  "jest.e2e.config.json": IconSet["jest"],
  "jest.e2e.config.mjs": IconSet["jest"],
  "jest.e2e.config.ts": IconSet["jest"],
  "jest.json": IconSet["jest"],
  "jest.setup.js": IconSet["jest"],
  "jest.setup.ts": IconSet["jest"],
  "jest.teardown.js": IconSet["jest"],
  "karma-main.js": IconSet["karma"],
  "karma-main.ts": IconSet["karma"],
  "karma.conf.coffee": IconSet["karma"],
  "karma.conf.js": IconSet["karma"],
  "karma.conf.ts": IconSet["karma"],
  "karma.config.js": IconSet["karma"],
  "karma.config.ts": IconSet["karma"],
  licence: IconSet["certificate"],
  "licence.md": IconSet["certificate"],
  "licence.txt": IconSet["certificate"],
  license: IconSet["certificate"],
  "license.md": IconSet["certificate"],
  "license.txt": IconSet["certificate"],
  makefile: IconSet["makefile"],
  "manifest.in": IconSet["python-misc"],
  "manifest.mf": IconSet["settings"],
  "meson.build": IconDef.file,
  // "meson" not available
  "milestones.md": IconSet["roadmap"],
  "milestones.txt": IconSet["roadmap"],
  "mocha.opts": IconSet["mocha"],
  "nest-cli.json": IconDef.file,
  // "nest" not available
  "nestconfig.json": IconDef.file,
  // "nest" not available
  "netlify.json": IconDef.file,
  // "netlify" not available
  "netlify.toml": IconDef.file,
  // "netlify" not available
  "netlify.yaml": IconDef.file,
  // "netlify" not available
  "netlify.yml": IconDef.file,
  // "netlify" not available
  "nodemon-debug.json": IconDef.file,
  // "nodemon" not available
  "nodemon.json": IconDef.file,
  // "nodemon" not available
  "now.json": IconSet["vercel"],
  "nuget.config": IconSet["nuget"],
  "nuget.exe": IconSet["nuget"],
  "nuxt.config.js": IconSet["nuxt"],
  "nuxt.config.ts": IconSet["nuxt"],
  "nx.json": IconDef.file,
  // "nrwl" not available
  "package-lock.json": IconSet["nodejs"],
  "package.json": IconSet["nodejs"],
  pipfile: IconSet["python-misc"],
  "postcss.config.js": IconSet["postcss"],
  "prettier.config.js": IconSet["prettier"],
  "prisma.yml": IconDef.file,
  // "prisma" not available
  procfile: IconSet["heroku"],
  "procfile.windows": IconSet["heroku"],
  "project.graphcool": IconDef.file,
  // "graphcool" not available
  "protractor.conf.coffee": IconSet["protractor"],
  "protractor.conf.js": IconSet["protractor"],
  "protractor.conf.ts": IconSet["protractor"],
  "protractor.config.js": IconSet["protractor"],
  "protractor.config.ts": IconSet["protractor"],
  readme: IconSet["readme"],
  "readme.md": IconSet["readme"],
  "readme.txt": IconSet["readme"],
  "release.config.js": IconSet["semantic-release"],
  "requirements.txt": IconSet["python-misc"],
  "roadmap.md": IconSet["roadmap"],
  "roadmap.txt": IconSet["roadmap"],
  "rollup-config.js": IconDef.file,
  // "rollup" not available
  "rollup-config.ts": IconDef.file,
  // "rollup" not available
  "rollup.config.base.js": IconDef.file,
  // "rollup" not available
  "rollup.config.base.ts": IconDef.file,
  // "rollup" not available
  "rollup.config.common.js": IconDef.file,
  // "rollup" not available
  "rollup.config.common.ts": IconDef.file,
  // "rollup" not available
  "rollup.config.dev.js": IconDef.file,
  // "rollup" not available
  "rollup.config.dev.ts": IconDef.file,
  // "rollup" not available
  "rollup.config.js": IconDef.file,
  // "rollup" not available
  "rollup.config.prod.js": IconDef.file,
  // "rollup" not available
  "rollup.config.prod.ts": IconDef.file,
  // "rollup" not available
  "rollup.config.prod.vendor.js": IconDef.file,
  // "rollup" not available
  "rollup.config.prod.vendor.ts": IconDef.file,
  // "rollup" not available
  "rollup.config.ts": IconDef.file,
  // "rollup" not available
  "routes.js": IconSet["routing"],
  "routes.jsx": IconSet["routing"],
  "routes.ts": IconSet["routing"],
  "routes.tsx": IconSet["routing"],
  "routing.js": IconSet["routing"],
  "routing.jsx": IconSet["routing"],
  "routing.ts": IconSet["routing"],
  "routing.tsx": IconSet["routing"],
  security: IconSet["lock"],
  "security.md": IconSet["lock"],
  "security.txt": IconSet["lock"],
  "stencil.config.js": IconDef.file,
  // "stencil" not available
  "stencil.config.ts": IconDef.file,
  // "stencil" not available
  "stryker.conf.js": IconSet["stryker"],
  "stryker.conf.json": IconSet["stryker"],
  "stylelint.config.js": IconSet["stylelint"],
  "tailwind.config.js": IconSet["tailwindcss"],
  "tailwind.js": IconSet["tailwindcss"],
  tiltfile: IconDef.file,
  // "tilt" not available
  "timeline.md": IconSet["roadmap"],
  "timeline.txt": IconSet["roadmap"],
  unlicense: IconSet["certificate"],
  "unlicense.md": IconSet["certificate"],
  "unlicense.txt": IconSet["certificate"],
  vagrantfile: IconSet["vagrant"],
  "vercel.json": IconSet["vercel"],
  "vue.config.js": IconSet["vue-config"],
  "vue.config.ts": IconSet["vue-config"],
  "wallaby.conf.js": IconDef.file,
  // "wallaby" not available
  "wallaby.js": IconDef.file,
  // "wallaby" not available
  "webpack.base.js": IconSet["webpack"],
  "webpack.base.ts": IconSet["webpack"],
  "webpack.client.js": IconSet["webpack"],
  "webpack.client.ts": IconSet["webpack"],
  "webpack.common.js": IconSet["webpack"],
  "webpack.common.ts": IconSet["webpack"],
  "webpack.config.babel.js": IconSet["webpack"],
  "webpack.config.babel.ts": IconSet["webpack"],
  "webpack.config.base.babel.js": IconSet["webpack"],
  "webpack.config.base.babel.ts": IconSet["webpack"],
  "webpack.config.base.js": IconSet["webpack"],
  "webpack.config.base.ts": IconSet["webpack"],
  "webpack.config.client.js": IconSet["webpack"],
  "webpack.config.client.ts": IconSet["webpack"],
  "webpack.config.coffee": IconSet["webpack"],
  "webpack.config.common.babel.js": IconSet["webpack"],
  "webpack.config.common.babel.ts": IconSet["webpack"],
  "webpack.config.common.js": IconSet["webpack"],
  "webpack.config.common.ts": IconSet["webpack"],
  "webpack.config.dev.babel.js": IconSet["webpack"],
  "webpack.config.dev.babel.ts": IconSet["webpack"],
  "webpack.config.dev.js": IconSet["webpack"],
  "webpack.config.dev.ts": IconSet["webpack"],
  "webpack.config.js": IconSet["webpack"],
  "webpack.config.prod.babel.js": IconSet["webpack"],
  "webpack.config.prod.babel.ts": IconSet["webpack"],
  "webpack.config.prod.js": IconSet["webpack"],
  "webpack.config.prod.ts": IconSet["webpack"],
  "webpack.config.production.babel.js": IconSet["webpack"],
  "webpack.config.production.babel.ts": IconSet["webpack"],
  "webpack.config.production.js": IconSet["webpack"],
  "webpack.config.production.ts": IconSet["webpack"],
  "webpack.config.server.js": IconSet["webpack"],
  "webpack.config.server.ts": IconSet["webpack"],
  "webpack.config.staging.babel.js": IconSet["webpack"],
  "webpack.config.staging.babel.ts": IconSet["webpack"],
  "webpack.config.staging.js": IconSet["webpack"],
  "webpack.config.staging.ts": IconSet["webpack"],
  "webpack.config.test.js": IconSet["webpack"],
  "webpack.config.test.ts": IconSet["webpack"],
  "webpack.config.ts": IconSet["webpack"],
  "webpack.config.vendor.js": IconSet["webpack"],
  "webpack.config.vendor.production.js": IconSet["webpack"],
  "webpack.config.vendor.production.ts": IconSet["webpack"],
  "webpack.config.vendor.ts": IconSet["webpack"],
  "webpack.dev.js": IconSet["webpack"],
  "webpack.dev.ts": IconSet["webpack"],
  "webpack.development.js": IconSet["webpack"],
  "webpack.development.ts": IconSet["webpack"],
  "webpack.dist.js": IconSet["webpack"],
  "webpack.dist.ts": IconSet["webpack"],
  "webpack.js": IconSet["webpack"],
  "webpack.prod.js": IconSet["webpack"],
  "webpack.prod.ts": IconSet["webpack"],
  "webpack.production.js": IconSet["webpack"],
  "webpack.production.ts": IconSet["webpack"],
  "webpack.server.js": IconSet["webpack"],
  "webpack.server.ts": IconSet["webpack"],
  "webpack.test.js": IconSet["webpack"],
  "webpack.test.ts": IconSet["webpack"],
  "webpack.ts": IconSet["webpack"],
  "webpackfile.js": IconSet["webpack"],
  "webpackfile.ts": IconSet["webpack"],
  "yarn-error.log": IconSet["yarn"],
  "yarn.lock": IconSet["yarn"]
};

// src/sub-extensions.ts
var IconSubExt = {
  "azure-pipelines.yaml": IconSet["azure-pipelines"],
  "azure-pipelines.yml": IconSet["azure-pipelines"],
  "blade.php": IconSet["laravel"],
  "css.map": IconSet["css-map"],
  "d.ts": IconSet["typescript-def"],
  "e2e-spec.js": IconSet["test-js"],
  "e2e-spec.ts": IconSet["test-ts"],
  "gitlab-ci.yml": IconSet["gitlab"],
  "inky.php": IconSet["laravel"],
  "js.map": IconSet["javascript-map"],
  "js.snap": IconSet["test-js"],
  "jsx.snap": IconSet["test-jsx"],
  "mjs.map": IconSet["javascript-map"],
  "routes.js": IconSet["routing"],
  "routes.jsx": IconSet["routing"],
  "routes.ts": IconSet["routing"],
  "routes.tsx": IconSet["routing"],
  "routing.js": IconSet["routing"],
  "routing.jsx": IconSet["routing"],
  "routing.ts": IconSet["routing"],
  "routing.tsx": IconSet["routing"],
  "sln.dotsettings": IconSet["settings"],
  "spec.js": IconSet["test-js"],
  "spec.jsx": IconSet["test-jsx"],
  "spec.ts": IconSet["test-ts"],
  "spec.tsx": IconSet["test-jsx"],
  "stories.js": IconSet["storybook"],
  "stories.jsx": IconSet["storybook"],
  "stories.ts": IconSet["storybook"],
  "stories.tsx": IconSet["storybook"],
  "story.js": IconSet["storybook"],
  "story.jsx": IconSet["storybook"],
  "story.ts": IconSet["storybook"],
  "story.tsx": IconSet["storybook"],
  "test.js": IconSet["test-js"],
  "test.jsx": IconSet["test-jsx"],
  "test.ts": IconSet["test-ts"],
  "test.tsx": IconSet["test-jsx"],
  "tf.json": IconSet["terraform"],
  "ts.snap": IconSet["test-ts"],
  "tsx.snap": IconSet["test-jsx"],
  "vcxitems.filters": IconSet["visualstudio"],
  "vcxproj.filters": IconSet["visualstudio"]
};

// src/icons.ts
var S_IFMT = 61440;
var S_IFDIR = 16384;
var S_IFIFO = 4096;
var S_IFLNK = 40960;
var S_IFSOCK = 49152;
var S_IXUSR = 64;
function getIndicator(mode) {
  const fileType = mode & S_IFMT;
  if (fileType === S_IFDIR) {
    return "/";
  }
  if (fileType === S_IFIFO) {
    return "|";
  }
  if (fileType === S_IFLNK) {
    return "@";
  }
  if (fileType === S_IFSOCK) {
    return "=";
  }
  if (mode & S_IXUSR) {
    return "*";
  }
  return "";
}
function getIcon(name, ext, indicator) {
  let iconInfo;
  const DOT = ".";
  if (indicator === "/") {
    const dirKey = (name + ext).toLowerCase();
    iconInfo = IconDir[dirKey];
    if (!iconInfo) {
      if (name.length === 0 || name[0] === DOT) {
        iconInfo = IconDef.hiddendir;
      } else {
        iconInfo = IconDef.dir;
      }
    }
  } else {
    const fullName = (name + ext).toLowerCase();
    const isHidden = name.length === 0 || name[0] === DOT;
    iconInfo = IconFileName[fullName];
    if (!iconInfo && ext === ".go" && name.endsWith("_test")) {
      iconInfo = IconSet["go-test"];
    }
    if (!iconInfo) {
      const parts = name.split(".");
      if (parts.length > 1 && parts[0] !== "") {
        const subExtKey = (parts[parts.length - 1] + ext).toLowerCase();
        iconInfo = IconSubExt[subExtKey];
      }
    }
    if (!iconInfo) {
      const extKey = ext.startsWith(".") ? ext.slice(1).toLowerCase() : ext.toLowerCase();
      iconInfo = IconExt[extKey];
      if (!iconInfo) {
        iconInfo = isHidden ? IconDef.hiddenfile : IconDef.file;
      }
    }
  }
  let isExecutable = false;
  if (indicator === "*") {
    if (iconInfo.glyph === IconDef.file.glyph) {
      iconInfo = IconDef.exe;
    }
    isExecutable = true;
  }
  const color = isExecutable ? "\x1B[38;2;76;175;80m" : `\x1B[38;2;${iconInfo.color[0]};${iconInfo.color[1]};${iconInfo.color[2]}m`;
  return {
    glyph: iconInfo.glyph,
    color
  };
}

export { IconDef, IconDir, IconExt, IconFileName, IconSet, IconSubExt, getIcon, getIndicator };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map